import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import LeftArrow from '../../../../../../../asset/svg/leftArrow.svg';
import VerifyOtp from '../../../../../../../asset/svg/verifyOtpImage.svg'
import TickSuccess from '../../../../../../../asset/svg/tickImageSuccess.svg'
import '../../../../../../../scss/pages/Attendance/Component/Asset/Assets/De-Register Asset/verifyOtpDeregisterAsset/verifyOtpDeregisterAsset.scss'
import OTPInput from "otp-input-react";
import 'react-phone-input-2/lib/style.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import Modal from '@mui/material/Modal';
import { ASSETS_REGISTER_PATH, DE_REGISTER_ASSET_PATH } from '../../../../../../../utils/Constants';
import { getLocalStoreString } from '../../../../../../../utils/Helper';
import { CLEAR_DE_REGISTER_ASSET_STATE, DE_REGISTER_ASSET_LIST, HIDE_MODAL_SELECT_STORE, POST_DE_REGISTER_ASSET_OTP_VERIFIED_DATA, POST_REGISTER_ASSET_VERIFY_OTP_DATA, SHOW_MODAL_ASSETGROUP } from '../../../../../../../sagas/type';


function VerifyOtpDeregisterAsset() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const { mobileNumber, personName, status } = location?.state;
    const { SelectedStoreDatas, DeRegisterAssetList } = useSelector(mapStateToProps)
    const [OTP, setOTP] = useState("");
    const [otpError, setOtpError] = useState(false)
    const [open, setOpen] = useState(false);
    const [timer, setTimer] = useState(60)

    const handleBack = () => {
        navigate(DE_REGISTER_ASSET_PATH)
    }

    const handleClickOkay = () => {
        dispatch({ type: CLEAR_DE_REGISTER_ASSET_STATE })
        dispatch({ type: HIDE_MODAL_SELECT_STORE })
        navigate(ASSETS_REGISTER_PATH)
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
        setOpen(false)
    }

    const handleFormSubmit = () => {
        if (status == 200) {
            setTimer(60)
        }
        dispatch({
            type: POST_REGISTER_ASSET_VERIFY_OTP_DATA,
            payload: { storeData: SelectedStoreDatas },
            setOtpError,
            enqueueSnackbar: enqueueSnackbar,
        });
        setOTP("")
    };

    const handleVerifyOtp = () => {
        const purchaseData = DeRegisterAssetList?.map((item) => ({
            purchaseId: item?.purchaseId,
            assetId: item?.id,
            remarks: item?.remarks,
            assetCondition: item?.assetCondition,
            uploads: item?.uploads,

        }))
        const EmployeeCode = getLocalStoreString("EmployeeCode")
        const codeStore = SelectedStoreDatas && SelectedStoreDatas?.length && SelectedStoreDatas[0]?.code
        dispatch({
            type: POST_DE_REGISTER_ASSET_OTP_VERIFIED_DATA,
            payload: {
                purchases: purchaseData,
                storeCode: codeStore,
                employeeCode: EmployeeCode,
                otpCode: OTP,
            },
            setOpen: setOpen,
            setOtpError: setOtpError,
            enqueueSnackbar: enqueueSnackbar,
        });
        setOTP("")
    }

    const handleClose = (event, reason) => {
        if (reason !== "backdropClick") {
            setOpen(false);
        }
    };

    const handleOtp = (otp) => {
        setOtpError(false)
        setOTP(otp)
    }

    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1)
            }, 1000)
        } else {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval)
        };
    }, [timer])
    return (
        <div className='RegisterVerifyOtp-Container'>
            <div className='RegisterVerifyOtp-Container_header'>
                <div>
                    <img className='RegisterVerifyOtp-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='RegisterVerifyOtp-Container_header_content'>Verify OTP</span>
                </div>
            </div>
            <div className='RegisterVerifyOtp-Container_Verify-image-parent'>
                <div>
                    <img className='RegisterVerifyOtp-Container_Verify-image' src={VerifyOtp} />
                </div>
            </div>
            <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" bottom="20%" marginTop="20%" className='RegisterVerifyOtp-Container_section_verifyBox'>


                <div style={{ position: 'relative', display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography color="rgba(255, 255, 255, 0.50)" variant='h6' fontWeight={500} fontSize={14} position='relative' top='-1rem' >OTP sent to <span style={{ fontSize: "14px", fontWeight: "600", color: "white" }}>{personName}</span></Typography>
                </div>
                <div style={{ position: "relative", width: "100%", display: "flex", justifyContent: "center" }}>
                    <Typography position='relative' top='-1rem' color="rgba(255, 255, 255, 0.50)" fontSize='14px' ><span style={{ fontWeight: '500' }}> {mobileNumber && mobileNumber.length > 10 && `${mobileNumber}`}</span> </Typography>
                    <button onClick={handleFormSubmit} disabled={timer > 0} style={timer > 0 ? { border: 'none', backgroundColor: "transparent", position: 'absolute', right: '2%', top: "-15px", color: "white", cursor: 'pointer' } : { border: 'none', backgroundColor: 'transparent', color: "#FFF", position: 'absolute', top: "-15px", right: '2%', cursor: 'pointer' }}>
                        {timer > 0 ? `00:${timer < 10 ? `0${timer}` : timer}` : "Resend"}
                    </button>
                </div>

                <OTPInput value={OTP && OTP} inputStyles={{ border: ' 0.826px solid rgba(255, 255, 255, 0.20)' }} otpType="number" disabled={false} secure={false} onChange={(otp) => handleOtp(otp)} OTPLength={6} className='RegisterVerifyOtp-Container_section_verifyBox_otp-input' />
                {/* {otpError && <Typography color="#FC7C7C" fontSize="14px" style={{ marginTop: "5px" }}>Please enter the correct OTP</Typography>} */}
                <button type='submit' disabled={OTP.length == 6 ? false : true} className='RegisterVerifyOtp-Container_section_verifyBox_active-button' onClick={handleVerifyOtp}>Verify</button>
            </Box >

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <div className='RegisterVerifyOtp-Container_boxContainer'>
                    <Box sx={{ backgroundColor: 'white', borderRadius: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', }}>
                        <img className='RegisterVerifyOtp-Container_tickSuccess' src={TickSuccess} alt="" />&nbsp;&nbsp;

                        <div>
                            <Typography className='RegisterVerifyOtp-Container_itsDone'>It’s done</Typography>
                            <Typography fontSize='12px' padding='10px' textAlign='center'>De-Registered Successfully</Typography>
                            <div className='RegisterVerifyOtp-Container_okbutton-container'>
                                <button className='RegisterVerifyOtp-Container_okbutton-container_button' style={{ border: "none" }} onClick={handleClickOkay}>Okay</button>
                            </div>
                        </div>

                    </Box>
                </div>
            </Modal>
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        SelectedStoreDatas: state?.attendanceConfig?.SelectedStoreDatas,
        DeRegisterAssetList: state?.attendanceConfig?.DeRegisterAssetList,
        GetOtpDeRegiaterAsset: state?.attendanceConfig?.GetOtpDeRegiaterAsset,
    }
}

export default VerifyOtpDeregisterAsset